<template>
  <div
    class="tooltip"
    :style="getStyles()"
    ref="container">
    <div
      class="box"
      :style="getColor()">
      <div class="content">
        {{text}}
      </div>
    </div>
    <div class="tip-wrapper">
      <n-tooltip-tip
        class="tip"
        :fill="color" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.tooltip {
  user-select: none;
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  box-shadow: $shadow--layer;
  .box {
    padding: 0.25rem $spacing--xxs;
  }
  .content {
    @extend %text-style--label;
    color: var(--color--white);
  }
  .tip-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

</style>

<script>
import { mapState } from 'vuex'
import TooltipTip from '@/components/TooltipTip'

const TOOLTIP_MARGIN_Y = 8

// This are used to keep the tooltip in a safe range.
// They're usually recalculated when the container is rendered.
let lastHalfWidth = 0
let lastHeightWithMargin = 0

function getTransform (x, y) {
  return `translate(${x}px, ${y}px)`
}

function getStyles (x, y) {
  return {
    transform: getTransform(x, y)
  }
}

export default {
  name: 'tooltip',
  components: {
    'n-tooltip-tip': TooltipTip
  },
  computed: {
    ...mapState({
      x: (state) => state.tooltip.x,
      y: (state) => state.tooltip.y,
      text: (state) => state.tooltip.text,
      color: (state) => state.tooltip.color
    })
  },
  methods: {
    getColor () {
      return `background-color: ${this.color}`
    },
    getStyles () {
      if (this.$refs.container) {
        const { width, height } = this.$refs.container.getBoundingClientRect()
        const halfWidth = width * 0.5
        const heightWithMargin = height + TOOLTIP_MARGIN_Y
        lastHalfWidth = halfWidth
        lastHeightWithMargin = heightWithMargin
        return getStyles(this.x - halfWidth, this.y - heightWithMargin)
      }
      return getStyles(this.x - lastHalfWidth, this.y - lastHeightWithMargin)
    }
  }
}
</script>
